import { render, staticRenderFns } from "./MHeader.vue?vue&type=template&id=4010bef2&"
import script from "./MHeader.vue?vue&type=script&lang=ts&"
export * from "./MHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports